<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <main>
    <IntroSection />
    <ProductsSection />
    <AboutSection />
    <ContactSection />
  </main>
</template>

<script setup>
// eslint-disable-next-line vue/multi-word-component-names
import { defineOptions } from 'vue'

defineOptions({ name: 'HomePage' })

import IntroSection from '../components/IntroSection.vue'
import AboutSection from '../components/AboutSection.vue'
import ProductsSection from '../components/ProductsSection.vue'
import ContactSection from '../components/ContactSection.vue'
</script>
